import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import { h5Styles, smallcapsBold14Styles } from "@constants/typography"
import { Close } from "@components/icons"

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: flex;
  height: 72px;
  padding: 0 20px;
  border-bottom: 1px solid ${colors.dividerLineGray};

  @media ${breakpoints.tablet} {
    padding: 0 32px;
  }

  @media ${breakpoints.laptop} {
    height: 114px;
    padding: 0 64px;
  }
`

const Text = styled.div`
  ${smallcapsBold14Styles}
  flex-grow: 1;
  padding-top: 4px;
  padding-left: 2px;
  text-align: left;

  @media ${breakpoints.laptop} {
    ${h5Styles}
    padding-top: 6px;
  }
`

const CloseButton = styled.button`
  flex-direction: row;
  align-items: center;
  display: flex;
  transform: translateX(18px);
  width: 48px;
  height: 48px;
  padding: 6px;
  outline: none;
  border: none;
  background: none;

  &:focus,
  &:active {
    outline: none;
  }

  @media ${breakpoints.laptop} {
    transform: translateX(-6px);
    transition: background-color ${animation.quick} ${cubicBezier};
    width: 44px;
    height: 44px;
    border-radius: 100px;
    background-color: ${colors.dividerLineGray};

    svg {
      transition: stroke ${animation.quick} ${cubicBezier};
      stroke: ${colors.mediumDarkGray};
    }

    &:hover {
      background-color: ${colors.lightGray};
      cursor: pointer;

      svg {
        stroke: ${colors.offBlack};
      }
    }
  }
`

interface HeaderProps {
  cartCount: number
  onRequestClose: () => void
}

const Header: React.FC<HeaderProps> = ({ cartCount, onRequestClose }) => {
  return (
    <Container>
      <Text>{`Cart (${cartCount})`}</Text>
      <CloseButton onClick={onRequestClose}>
        <Close />
      </CloseButton>
    </Container>
  )
}

export default Header
